var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");require("./cljs.core.js");
$CLJS.Z=Error();